import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 21H6c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1m4-17h4v16h-4z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 21h-4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1"
    }, null, -1)
  ]))]))
}
export default { render: render }